<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Strony</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-tabs v-model="activeTab">
        <v-tab v-for="slot in slotsTypes" exact :key="slot.name" :to="slot.route">{{ slot.name }}</v-tab>
        <v-layout text-xs-right>
          <v-flex>
            <check-permission permissions="PAGE.ADD">
              <v-btn large color="error" @click="showAddModal">DODAJ STRONĘ</v-btn>
            </check-permission>
          </v-flex>
        </v-layout>
      </v-tabs>

      <material-table
        editPerm="PAGE.UPDATE"
        deletePerm="PAGE.DELETE"
        :headers="table.headers"
        :items="list"
        :actions="true"
        :hideActions="false"
        :total-count="count"
        :search="search"
        @pagination="reloadList"
        @add="showAddModal"
        @edit="showEditModal"
        @delete="showDeleteDialog"
      ></material-table>

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy napewno chcesz usunąć stronę?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      ></material-dialog>
    </material-card>

    <modal
      :show="showModal"
      :id="idToEdit"
      :edit="!!idToEdit"
      @close="hideModal"
      @save="addPage"
      @update="updatePage"
    ></modal>
  </v-container>
</template>
<script>
import { mapState } from 'vuex';
import {
  PageTypeTranslation,
  StateTranslation,
  State,
  StateString,
  PageSlots,
  PageSlotsTranslation,
  PageType
} from '@witkac/kartamiejska-shared';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import Modal from './add.modal';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';

// @vuese
// Wyświetlanie listy Stron
// @group Pages
export default {
  data() {
    return {
      search: '',
      table: {
        headers: [
          { value: 'priority', text: 'Priorytet ', sortable: true },
          { value: 'name', text: 'Nazwa', sortable: true },
          { value: 'typeTranslated', text: 'Typ', sortable: true, paginationValue: 'type' },
          { value: 'stateTranslated', text: 'Stan', sortable: true, paginationValue: 'state' }
        ]
      },
      activeTab: this.$route.path
    };
  },
  mixins: [
    listMixin(
      'pages',
      {
        listError: 'Wystąpił błąd podczas pobierania listy stron.',
        getError: 'Wystąpił błąd podczas pobierania danych strony.',
        added: 'Dodano stronę.',
        addError: 'Nie udało się dodać strony.',
        updated: 'Zaktualizowano dane strony.',
        updateError: 'Nie udało się zaktualizować danych strony.',
        deleted: 'Usunięto stronę.',
        deleteError: 'Nie udało się usunąć strony.'
      },
      {},
      (to, from, next) => {
        const slots = to.params.slot;
        const filters = {
          slots: slots ? [slots] : undefined,
          noSlots: !slots || undefined,
          count: 10,
          order: 'priority',
          start: 0
        };
        store
          .dispatch(`pages/list`, filters)
          .then(() => next())
          .catch(err =>
            store.dispatch('notifyError', {
              title: messages.listError
            })
          );
      }
    )
  ],
  components: {
    MaterialCard,
    MaterialDialog,
    MaterialTable,
    Modal
  },
  computed: {
    ...mapState({
      list: state => {
        const list = state.pages.list.map(item => {
          item.typeTranslated = PageTypeTranslation[item.type];
          item.stateTranslated =
            State[item.state] === State.NOT_CONFIRMED
              ? StateTranslation[State[StateString.INACTIVE]]
              : StateTranslation[State[item.state]];
          return item;
        });
        return list;
      }
    }),
    slotsTypes() {
      const slotsTypes = Object.keys(PageSlots).map(slot => ({
        route: `/pages/${PageSlots[slot]}`,
        name: PageSlotsTranslation[PageSlots[slot]]
      }));

      slotsTypes.push({
        route: '/pages',
        name: 'Ogólne'
      });
      return slotsTypes;
    }
  },
  methods: {
    // @vuese
    // Dodaje stronę
    addPage(data) {
      this.add({ page: { ...data } });
    },
    // @vuese
    // Aktualizuje stronę
    updatePage(data) {
      const id = data.id;
      data.id = undefined;
      this.update({ page: { ...data }, id });
    },
    // @vuese
    // Ustawia filtr paginacji
    filters(pagination) {
      const slots = this.$router.currentRoute.params.slot;
      return { ...pagination, slots: slots ? [slots] : undefined, noSlots: !slots || undefined };
    }
  },
  beforeRouteUpdate(to, from, next) {
    const slots = to.params.slot;
    const filters = {
      slots: slots ? [slots] : undefined,
      noSlots: !slots || undefined,
      count: 10,
      order: 'priority',
      start: 0
    };
    store
      .dispatch(`pages/list`, filters)
      .then(() => next())
      .catch(err =>
        store.dispatch('notifyError', {
          title: messages.listError
        })
      );
  }
};
</script>